import styled from 'styled-components'

export const IconWrapper = styled.div`
  cursor: pointer;
  width: 32px;
`
export const ButtonWrapper = styled.span`
  margin-bottom: 8px;
`
